import React, { useState } from 'react';
import { useGetIdentity } from 'react-admin';
import Parse from 'parse';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  Stack,
  Avatar,
  Skeleton,
  IconButton,
  Tooltip
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { EditProfile } from '../dialog/EditProfile';

export const BasicInfo = () => {
  const { isPending, data, refetch } = useGetIdentity();
  const currentUser = Parse.User.current();
  const [openEdit, setOpenEdit] = useState(false);

  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);
  const handleSuccess = () => {
    refetch();
  };

  const rawData = [
    {
      id: 1,
      name: 'Admin ID',
      value: currentUser?.id || '---',
      color: '#fff'
    },
    {
      id: 2,
      name: 'Username',
      value: currentUser?.get('username') || '---',
      color: '#fff'
    },
    {
      id: 3,
      name: 'Email',
      value: currentUser?.get('email') || '---',
      color: '#fff'
    },
    {
      id: 4,
      name: 'Phone',
      value: currentUser?.get('phone') || '---',
      color: '#fff'
    },
    {
      id: 5,
      name: 'Role',
      value: data?.role || '---',
      color: '#FFD700'
    },
    {
      id: 6,
      name: 'Status',
      value: 'Active',
      color: '#18DC8B',
      icon: '/Assets/Icons/checkmark-square.svg'
    }
  ];

  return (
    <React.Fragment>
      {isPending ? (
        <Card
          variant="outlined"
          sx={{
            backgroundColor: '#242424',
            borderRadius: '8px',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}
        >
          <CardContent>
            <Skeleton
              width="100%"
              height={100}
              sx={{ mt: 1, bgcolor: 'rgba(255, 255, 255, 0.1)' }}
            />
            <Skeleton width="50%" height={40} sx={{ mt: 1, bgcolor: 'rgba(255, 255, 255, 0.1)' }} />
            <Skeleton width="50%" height={40} sx={{ mt: 1, bgcolor: 'rgba(255, 255, 255, 0.1)' }} />
            <Skeleton width="50%" height={40} sx={{ mt: 1, bgcolor: 'rgba(255, 255, 255, 0.1)' }} />
          </CardContent>
        </Card>
      ) : (
        <Card
          variant="outlined"
          sx={{
            backgroundColor: '#242424',
            borderRadius: '8px',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <CardContent sx={{ flexGrow: 1 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 2
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: '#FFF',
                  fontSize: 18,
                  fontWeight: 500
                }}
              >
                Basic Information
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Tooltip title="Edit Profile">
                  <IconButton
                    onClick={handleOpenEdit}
                    sx={{
                      backgroundColor: 'rgba(255, 193, 7, 0.1)',
                      color: '#FFC107',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 193, 7, 0.2)'
                      }
                    }}
                  >
                    <EditIcon sx={{ fontSize: 20 }} />
                  </IconButton>
                </Tooltip>
                <Box
                  sx={{
                    backgroundColor: 'rgba(255, 215, 0, 0.20)',
                    padding: '8px',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <img
                    src="/Assets/Icons/permissions.svg"
                    alt="Permissions"
                    style={{ width: 24, height: 24 }}
                  />
                </Box>
              </Box>
            </Box>

            <Stack
              direction="row"
              spacing={2}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                mb: 2
              }}
            >
              <Avatar alt="User" src="/Assets/Images/user.png" sx={{ width: 64, height: 64 }} />
            </Stack>

            <Grid container spacing={1}>
              {rawData?.map((ele) => (
                <Grid item xs={12} sm={6} md={6} key={ele.id}>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        color: '#999',
                        fontSize: 14,
                        fontWeight: 400,
                        mt: 2
                      }}
                    >
                      {ele?.name}
                    </Typography>

                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      {ele?.icon && (
                        <img src={ele?.icon} alt={ele?.name} style={{ width: 18, height: 18 }} />
                      )}
                      <Typography
                        variant="span"
                        sx={{
                          color: ele?.color,
                          fontSize: 14,
                          fontWeight: 400,
                          ml: ele?.icon ? 1 : 0
                        }}
                      >
                        {ele?.value}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      )}
      <EditProfile open={openEdit} onClose={handleCloseEdit} onSuccess={handleSuccess} />
    </React.Fragment>
  );
};
